
<section #title>

    <div class="title" [class.dencapsulate]="animate">
        <h2 class="f-light f-upper" [innerHTML]="encapsulate(content[language].menu.apartments)"></h2>
        <p class="types f-light f-upper">
            <ng-container *ngFor="let item of content[language].apartments.types; let a = index">
                <span (click)="goTo(a)" [class.selected]="current == a">
                    <span [innerHTML]="encapsulate(item.title)">
                        
                    </span>
                    <span [innerHTML]="encapsulate('       ')">
                                       
                    </span>
                        <img *ngIf="item.salePercent == 100 && modal== false && modal!==0 " class="mini-logo-sale" src="assets/content/sale/100.png" alt="">
                        <img *ngIf="item.salePercent == 80 && modal== false && modal!==0" class="mini-logo-sale" src="assets/content/sale/80.png" alt="">
                        
                    
                </span><br>
            </ng-container>
        </p>

        <p class="text f-light" [innerHTML]="encapsulate(content[language].apartments.text)"></p>

        <!--<button class="f-upper f-center" [class.animate]="animate" (click)="modal = true">{{ language == 'en' ? 'See the options' : 'Veja as plantas' }}</button>-->
    </div>

    <div class="gallery-wrapper" #checkpoint>
        <owl-carousel-o
            #galleryEl
            class="gallery"
            [options]="gallery"
            (translated)="translated2($event)"
            [style.top]="((1 - offsetscroll) * 40) + 'rem'">
            <ng-template carouselSlide *ngFor="let item of content[language].apartments.types; let index = index">
                <article class="container apartment" [style.background-image]="'url(assets/content/' + item.image + ')'">
                    <div class="logo-sale">
                
                        <img *ngIf="item.salePercent == 100" src="assets/content/sale/100.png" alt="">
                        <img *ngIf="item.salePercent == 80" src="assets/content/sale/80.png" alt="">
                    </div> 
                    <div class="info">
                        <div class="hat f-upper f-light">Essence</div>
                        <h3 class="f-upper f-light" [innerHTML]="item.title"></h3>
                        <!--div class="text" [innerHTML]="item.text"></div-->
                        <button class="f-upper f-center" (click)="omodal(index)">{{ language == 'en' ? 'See more' : 'Veja mais' }}</button>
                    </div>
                    <small>{{ language == 'pt' ? 'Perspectiva meramente ilustrativa' : 'Illustrative perspective' }}</small>
                </article>
            </ng-template>
        </owl-carousel-o>
    </div>

    <!-- <div class="gallery-counter f-light f-center" [style.transform]="'translate(0, ' + ((1 - offsetscroll) * 40) + 'rem)'">
        {{ slidePosition }} / {{ content[language].apartments.types.length }}
    </div> -->

    

    
</section >
<section #title>
    <div class="f-center div-contact">
        <button (click)="redirectWhatsApp()" class="f-light f-center">{{ language == 'en' ? 'talk to the mediator' : 'Fale com o mediador' }}</button>
    </div>
</section>

<section class="plants" [class.visible]="modal !== false">
    <div class="header d-flex align-center">
        <div class="logo"></div>
        <ng-container *ngFor="let item of content[language].apartments.types; let a = index">
            <span class="type" (click)="omodal(a, true)" [class.selected]="modal === a"><span [innerHTML]="item.title"></span></span><br>
        </ng-container>
        
        <button class="close" (click)="omodal(false)">x</button>
    </div>
    <div class="content" [class.omodalAnimate]="omodalAnimate">
        <div class="plants-gallery-wrapper" *ngIf="modal !== false">
            <div class="logo-sale">
                
                <img *ngIf="content[language].apartments.types[modal].salePercent == 100" src="assets/content/sale/100.png" alt="">
                <img *ngIf="content[language].apartments.types[modal].salePercent == 80" src="assets/content/sale/80.png" alt="">
            </div> 
            <owl-carousel-o #plantsGalleryEl
                class="plants-gallery"
                [options]="plantsGallery"
                (changed)="translated($event)">
                
                <ng-template carouselSlide *ngFor="let item of content[language].apartments.types[modal].gallery; let index = index">
                    <div>
                        <img src="assets/content/{{ item.p }}">
                        <div class="legend">{{ item.l }}</div>
                    </div>
                </ng-template>
            </owl-carousel-o>
            <div class="gallery-counter f-light f-center">
                {{ slidePosition }} / {{ content[language].apartments.types[modal].gallery.length }}
            </div>
        </div>

        <div class="text" *ngIf="modal !== false">
            <div class="l">
                <h3 class="f-regular" [innerHTML]="content[language].apartments.types[modal].title.replace(' ', '<br>')"></h3>
                <p [innerHTML]="content[language].apartments.types[modal].text"></p>
                <a href="assets/{{ content[language]['ps' + (4 - modal)] }}" target="_blank" rel="noopener" class="f-regular">
                    <span>CLIQUE AQUI PARA BAIXAR TODAS AS<br>
                            PLANTAS OU VEJA AS OPÇÕES ABAIXO</span>
                    <span>CLIQUE AQUI PARA BAIXAR<br>TODAS AS PLANTAS</span>
                </a>
            </div>

            <div class="r">
                <img src="assets/images/plants-{{ 4 - modal }}.png">
            </div>
        </div>

        <div class="gallery-plants-2" *ngIf="modal !== false">
            <owl-carousel-o
                [options]="plantsGallery2">
                <ng-template carouselSlide *ngFor="let item of content[language].apartments.types[modal].plants; let index = index">
                    <div><img src="assets/{{ item }}" (click)="zoom(modal, index)"></div>
                </ng-template>
            </owl-carousel-o>
        </div>
    </div>
</section>
